import { render } from "./modal.vue?vue&type=template&id=15b0bdd2&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=15b0bdd2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b0bdd2"]])

export default __exports__